<template>
  <div v-if="pace">

    <div class="progress_row">
        <div class="progress_bar_label">Ideal Pace - {{ pace.idealPace.toFixed(2) + '/' + pace.totalPace }}</div>
        <b-progress height="35px" :max="pace.totalPace">
            <b-progress-bar :value="pace.idealPace" class="sts_blc_Prgs"></b-progress-bar>
            <b-progress-bar :value="(pace.totalPace - pace.idealPace)" class="sts_blc_NotStarted"></b-progress-bar>
        </b-progress>
    </div>

    <div class="progress_row">
        <div class="progress_bar_label">Current Avg. Class Pace - {{ pace.classPace.toFixed(2) + '/' + pace.totalPace }}</div>
        <b-progress height="35px" :max="pace.totalPace">
            <b-progress-bar :value="pace.classPace" class="sts_blc_Fail"></b-progress-bar>
            <b-progress-bar :value="(pace.totalPace - pace.classPace)" class="sts_blc_NotStarted"></b-progress-bar>
        </b-progress>
    </div>

    <div class="progress_row" v-if="isStudentView">
        <div class="progress_bar_label">Your Pace - {{ pace.userPace.toFixed(2) + '/' + pace.totalPace }}</div>
        <b-progress height="35px" :max="pace.totalPace">
            <b-progress-bar :value="pace.userPace" class="sts_blc_Cmplt"></b-progress-bar>
            <b-progress-bar :value="(pace.totalPace - pace.userPace)" class="sts_blc_NotStarted"></b-progress-bar>
        </b-progress>
    </div>

  </div>
</template>

<script>
    export default {
      name: 'competencyPaceBar',
      props: ['pace', 'isStudentView'],
      data: () => {
        return {}
      }
    }
</script>

<style scoped>
	.progress_row {
		position: relative;
		width: 95%;
		margin-bottom: 14px;
	}
	.progress_row:last-child {
		margin-bottom: 0px;
	}
    .progress_bar_label {
        position: absolute;
        margin: auto;
        top: 0px;
        right: 0px;
        bottom: 0px;
        left: 0px;
        text-align: center;
        height: 22px;
        font-size: 14px;
        color: #fff;
    }
</style>



// WEBPACK FOOTER //
// src/app/course/components/CompetencyPaceBar.vue